import { render } from "./ProfileContent.vue?vue&type=template&id=8d98074c&scoped=true"
import script from "./ProfileContent.vue?vue&type=script&lang=js"
export * from "./ProfileContent.vue?vue&type=script&lang=js"

import "./ProfileContent.vue?vue&type=style&index=0&id=8d98074c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d98074c"]])

export default __exports__